module.exports = __webpack_public_path__ + "img/Support Summary.f8138134.png";